/* globals $ */
import Component from './component';

/* eslint-disable react/prefer-stateless-function, react/sort-comp */

const defaults = {};

export default class YoutubePlayer extends Component {
  constructor($context, options) {
    super($context, Object.assign({}, defaults, options));

    this.$context = $context;

    this.init();
  }

  init() {
    this.wrapLayout();
  }

  wrapLayout() {
    this.$context.wrap('<div class="video-container"></div>');
  }

  static initialize($context = $(document.body), options = {}) {
    return super.initialize('iframe[src*="youtube.com"]', YoutubePlayer, 'YoutubePlayer', $context, options);
  }
}



// WEBPACK FOOTER //
// ./front/bankomania/js/components/youtube-player.js